import React from "react";
import { Button } from "../ui/button";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { INTAKE } from "../../constants/testIds";

export const NavButtons = ({ onBack, onNext, nextLabel = "Continue", disabled, showBack = true, rightSlot }) => (
  <div className="flex items-center justify-between pt-6 border-t border-border mt-8">
    {showBack ? (
      <Button
        type="button"
        variant="ghost"
        onClick={onBack}
        data-testid={INTAKE.back}
        className="text-brand-darkgrey hover:text-brand-black rounded-sm"
      >
        <ChevronLeft className="h-4 w-4 mr-1" /> Back
      </Button>
    ) : (
      <span />
    )}
    {rightSlot || <Button
      type="button"
      onClick={onNext}
      disabled={disabled}
      data-testid={INTAKE.continue}
      className="bg-brand-black text-white hover:bg-brand-gold rounded-sm px-6 transition-colors duration-200"
    >
      {nextLabel} <ChevronRight className="h-4 w-4 ml-1" />
    </Button>}
  </div>
);
